/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

interface SettingsMenuRect { left: number; top: number; width: number; height: number }

/** Modal padding-box coordinates; preserve the opener's DOM and modal focus trap. */
export function resolveDataTableModalSettingsPosition({
  anchor, scope, viewport, contentHeight,
}: {
  anchor: SettingsMenuRect;
  scope: SettingsMenuRect;
  viewport: { width: number; height: number };
  contentHeight: number;
}) {
  const edge = 12;
  const anchorGap = 8;
  const leftLimit = Math.max(scope.left, 0) + edge;
  const rightLimit = Math.min(scope.left + scope.width, viewport.width) - edge;
  const topLimit = Math.max(scope.top, 0) + edge;
  const bottomLimit = Math.min(scope.top + scope.height, viewport.height) - edge;
  const width = Math.max(0, Math.min(340, rightLimit - leftLimit));
  const menuRight = Math.max(leftLimit + width, Math.min(anchor.left + anchor.width, rightLimit));
  const belowTop = anchor.top + anchor.height + anchorGap;
  const aboveBottom = anchor.top - anchorGap;
  const availableBelow = Math.max(0, bottomLimit - belowTop);
  const availableAbove = Math.max(0, aboveBottom - topLimit);
  const desiredHeight = Math.min(520, Math.max(0, contentHeight));
  const opensAbove = availableBelow < desiredHeight && availableAbove > availableBelow;
  const maxHeight = Math.min(520, opensAbove ? availableAbove : availableBelow);
  const visibleHeight = Math.min(desiredHeight, maxHeight);
  const desiredTop = opensAbove ? aboveBottom - visibleHeight : belowTop;
  const menuTop = Math.max(topLimit, Math.min(desiredTop, bottomLimit - visibleHeight));
  return {
    top: menuTop - scope.top,
    right: scope.left + scope.width - menuRight,
    width,
    maxHeight,
  };
}
